import { ref, toValue, type MaybeRefOrGetter } from 'vue'

import { injectSportsApiClient } from '@collector/shared-ui-domain'
import type { Participants } from '@collector/sportsapi-client'
import type {
  Participant,
  Season,
  SubParticipant,
} from '@collector/sportsapi-types'

import { toSortedBySurname } from '../utils/model.utils'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useSeasonSquad(
  season: MaybeRefOrGetter<Season>,
  participant: MaybeRefOrGetter<Participant>,
  options?: { compareFn?: (a: SubParticipant, b: SubParticipant) => number },
) {
  const sportsApiClient = injectSportsApiClient()
  const seasonSquadSubParticipants = ref<SubParticipant[]>([])

  async function fetchParticipantSquadBySeasonId(
    participantId: number,
    seasonId: number,
  ): Promise<Participants.Squad.SeasonSquadParticipant[]> {
    const squad = await sportsApiClient.Participants.Squad.getBySeasonId(
      participantId,
      seasonId,
    )

    return squad.api.data.participants || []
  }

  async function fetchSeasonSquad(): Promise<void> {
    const players = (await fetchParticipantSquadBySeasonId(
      toValue(participant).id,
      toValue(season).id,
    )) as unknown as SubParticipant[]

    seasonSquadSubParticipants.value = options?.compareFn
      ? [...players].sort(options.compareFn)
      : toSortedBySurname(players)
  }

  return {
    seasonSquadSubParticipants,
    fetchSeasonSquad,
  }
}
